import { render, staticRenderFns } from "./buyGetGiveaway.vue?vue&type=template&id=677d0616&"
import script from "./buyGetGiveaway.vue?vue&type=script&lang=ts&"
export * from "./buyGetGiveaway.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports